import React, { useState, useMemo } from "react";
import { CustomerAndPageSelector } from "./CustomerAndPageSelector";
import { LayoutEditor } from "./LayoutEditor";

export const LayoutStateWrapper = (props) => {
  const baseDCKey = "layouts";
  const {
    dynamicContent,
    initialGrid,
    customers,
    filteredBehaviours,
    dataOptions,
    behaviourOptions,
    saveLayout,
    deleteLayout,
    customer,
    customerCode,
    currentPageValue,
    setCustomerCode,
    setCustomer,
    setCurrentPageValue,
  } = props;
  const [grid, setGrid] = useState(initialGrid);
  // map customers to options for dropdown only if active
  const customerOptions = customers
    .filter((c) => c.isActive)
    .map((c) => {
      return { value: c.customerCode, text: `${c.name} (${c.customerCode})` };
    });

  const pageOptions = useMemo(() => {
    let options = [
      {
        text: "Overview",
        value: "overview",
      },
    ];
    if (Array.isArray(filteredBehaviours)) {
      for (let b = 0; b < filteredBehaviours.length; b++) {
        options.push({
          text: `Behaviour page ${filteredBehaviours[b].acronym} tab`,
          value: `behaviour${filteredBehaviours[b].acronym.toLowerCase()}`,
        });
      }
    }
    return options;
  }, [filteredBehaviours]);

  const updateGridFromDC = (newGridKey) => {
    if (newGridKey) {
      setGrid(JSON.parse(newGridKey[0].content_value));
    } else {
      setGrid({ sections: [] });
    }
  };

  const handelChangeCustomer = (e) => {
    const cust = customers.find((c) => c.customerCode === e);
    setCustomerCode(e);
    setCustomer(cust);

    const newGridKey =
      dynamicContent?.global[`${baseDCKey}__${e}__${currentPageValue}`];
    updateGridFromDC(newGridKey);
  };

  const handleChangePage = (e) => {
    setCurrentPageValue(e);
    const newGridKey =
      dynamicContent?.global[
        `${baseDCKey}__${customerCode.toLowerCase()}__${e}`
      ];
    updateGridFromDC(newGridKey);
  };

  const updateGrid = (newGrid) => {
    setGrid(newGrid);
  };

  return (
    <>
      <div className="mx-6 my-2">
        <h2 className="text-center">Behive Layout Editor</h2>
        <CustomerAndPageSelector
          customerOptions={customerOptions}
          customer={customer}
          pageOptions={pageOptions}
          currentPageValue={currentPageValue}
          handleChangeCustomer={handelChangeCustomer}
          handleChangePage={handleChangePage}
        />
      </div>
      <LayoutEditor
        dataOptions={dataOptions}
        behaviourOptions={behaviourOptions}
        grid={grid}
        setGrid={updateGrid}
        saveLayout={saveLayout}
        deleteLayout={deleteLayout}
      />
    </>
  );
};
